import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PRODUCT_LIST } from "@/data/products";

const products = PRODUCT_LIST.map((p, i) => ({
  key: p.slug,
  name: p.name,
  tagline: p.tagline,
  img: p.heroImg,
  tid: `product-card-${p.slug}`,
}));

export default function Products() {
  return (
    <section id="products" data-testid="products-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 reveal">
          <div>
            <p className="overline">Portfolio</p>
            <h2 className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A3626] leading-tight tracking-tight">
              What we move
            </h2>
          </div>
          <p className="text-[#4B5563] max-w-md text-base leading-relaxed">
            Four commodity families, one uncompromising quality benchmark. Every lot is
            traceable to origin and inspected before dispatch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {products.map((p, idx) => (
            <Link
              key={p.key}
              to={`/products/${p.key}`}
              data-testid={p.tid}
              className={`group relative overflow-hidden block reveal ${
                idx === 0 || idx === 3 ? "md:h-[520px]" : "md:h-[440px]"
              } h-[380px]`}
            >
              <img
                src={p.img}
                alt={p.name}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent"></div>
              <div className="relative h-full flex flex-col justify-end p-8 md:p-10">
                <div className="flex items-start justify-between gap-6">
                  <div>
                    <p className="overline text-[#E6C97A] mb-2">Category 0{idx + 1}</p>
                    <h3 className="font-serif-display text-white text-3xl md:text-4xl leading-tight">
                      {p.name}
                    </h3>
                    <p className="mt-3 text-white/80 max-w-md text-sm md:text-base">
                      {p.tagline}
                    </p>
                  </div>
                  <div className="shrink-0 h-12 w-12 border border-white/40 flex items-center justify-center transition-colors group-hover:bg-[#C5A059] group-hover:border-[#C5A059]">
                    <ArrowUpRight className="text-white" size={20} strokeWidth={1.5} />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
